document.addEventListener('alpine:init', () => {
  Alpine.data('directCheckout', function ({ mainVariantId, serviceVariantId, foundationVariantId }) {
    return {
      mainVariantId,
      serviceVariantId,
      foundationVariantId,
      loading: false,

      // Prüft Webflow Checkbox State für ein gegebenes Label-Ref
      isCheckedByRef(refName) {
        const label = this.$refs?.[refName];
        if (!label) return false;

        // Webflow setzt die Klasse oft auf dem inneren DIV oder Label
        if (label.classList.contains('w--redirected-checked')) return true;

        const box = label.querySelector('.w-checkbox-input');
        return box?.classList.contains('w--redirected-checked') ?? false;
      },

      addItem: async function (variantId, quantity = 1) {
        const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: Number(quantity) }]
          })
        });

        const data = await res.json();
        if (!res.ok) {
          throw new Error(data?.description || data?.message || 'Konnte nicht in den Warenkorb legen.');
        }
        return data;
      },

      checkout: async function (e) {
        if (this.loading) return;
        this.loading = true;

        try {
          const serviceChecked = this.isCheckedByRef('serviceLabel');
          const foundationChecked = this.isCheckedByRef('foundationLabel');

          console.log('[directCheckout]', {
            serviceChecked,
            serviceVariantId: this.serviceVariantId,
            foundationChecked,
            foundationVariantId: this.foundationVariantId,
            mainVariantId: this.mainVariantId
          });

          // Services zuerst (optional)
          if (this.serviceVariantId && serviceChecked) {
            await this.addItem(this.serviceVariantId, 1);
          }

          if (this.foundationVariantId && foundationChecked) {
            await this.addItem(this.foundationVariantId, 1);
          }

          // Hauptprodukt
          await this.addItem(this.mainVariantId, 1);

          window.location.href = '/checkout';
        } catch (err) {
          console.error(err);
          alert(err?.message || 'Fehler beim Checkout.');
        } finally {
          this.loading = false;
        }
      }
    };
  });
});
